export const dataSeller = [
  {
    imgSr:
      "https://www.jiomart.com/images/product/150x150/490008739/parle-g-original-glucose-biscuits-800-g-0-20210115.jpg",
    heading: "Parle-G Biscuits 800 g ",
    price: "67.50",
    mrp: "M.R.P: 75.00",
    save: "You Save: 7.50",
  },
  {
    imgSr:
      "https://www.jiomart.com/images/product/150x150/490003834/maggi-2-minute-masala-instant-noodles-560-g-0-20210811.jpg",
    heading: "Maggi Noodles 560g ",
    price: "79.00",
    mrp: "M.R.P: 96.00",
    save: "You Save: 17.00",
  },
  {
    imgSr:
      "https://www.jiomart.com/images/product/150x150/590108360/sugar-m-2-kg-0-20210316.jpg",
    heading: "Sugar clear (M) 2 kg",
    price: " 81.00",
    mrp: "M.R.P:  95.00",
    save: "You Save:  14.00",
  },
  {
    imgSr:
      "https://www.jiomart.com/images/product/150x150/491349660/chakki-atta-10-kg-0-20210301.jpg",
    heading: "Chakki  gold Atta 10 kg",
    price: "285.00",
    mrp: "M.R.P: 375.00",
    save: "You Save: 90.00",
  },
  {
    imgSr:
      "https://www.jiomart.com/images/product/420x420/490915877/lux-rose-vitamin-e-soft-glowing-skin-soap-bar-150-g-pack-of-3-0-20210818.jpg",
    heading: "Lux Rose 150g (Pack of 3)",
    price: "96.00",
    mrp: " M.R.P: 149.00",
    save: "You Save:  53.00",
  },
  {
    imgSr:
      "https://www.jiomart.com/images/product/420x420/491215527/whisper-ultra-wings-sanitary-napkin-with-wings-xl-44-pads-0-20210112.jpg",
    heading: "Whisper Ultra  (XL+) 44 pads",
    price: " 339.00",
    mrp: " M.R.P: 449.00",
    save: "You Save: 110.00",
  },
  {
    imgSr:
      "https://www.jiomart.com/images/product/150x150/490672482/dabur-red-toothpaste-200-100-g-with-free-toothbrush-0-20210514.jpg",
    heading: "Dabur Red Toothpaste 300 g ",
    price: "103.34",
    mrp: "M.R.P:  155.00",
    save: "You Save:  51.66",
  },
  {
    imgSr:
      "https://www.jiomart.com/images/product/420x420/491441280/surf-excel-matic-top-load-detergent-powder-4-kg-get-extra-2-kg-free-0-20210125.jpg",
    heading: "Surf Excel  4 kg ( Extra 2 kg Free)",
    price: " 869.00",
    mrp: "M.R.P: 1100.00",
    save: "You Save:  231.00",
  },
  {
    imgSr:
      "https://www.jiomart.com/images/product/150x150/491215021/gala-no-dust-broom-xl-0-20210825.jpg",
    heading: "Gala No Dust Broom (XL)",
    price: " 159.00",
    mrp: " M.R.P: 200.00",
    save: "You Save: 41.00",
  },
  {
    imgSr:
      "https://www.jiomart.com/images/product/150x150/490010199/amul-cheese-block-1-kg-carton-0-20210324.jpg",
    heading: "Amul Cheese Block 1 kg (Carton)",
    price: " 437.00",
    mrp: " M.R.P: 470.00",
    save: "You Save: 33.00",
  },
];

export const posterimg = [
  {
    img: "https://www.jiomart.com/images/cms/aw_rbslider/slides/1632332387_Kelloggs-Range_Jio_Mart_600x350.jpg",
  },
  {
    img: "https://www.jiomart.com/images/cms/aw_rbslider/slides/1632404550_colwm.jpg",
  },
  {
    img: "https://www.jiomart.com/images/cms/aw_rbslider/slides/1632404398_fwm.jpg",
  },
  {
    img: "https://www.jiomart.com/images/cms/aw_rbslider/slides/1629988766_webmini.jpg",
  },
  {
    img: "https://www.jiomart.com/images/cms/aw_rbslider/slides/1623423184_wm.jpg",
  },
  {
    img: "https://www.jiomart.com/images/cms/aw_rbslider/slides/1607437940_buybig_webmini.jpg",
  },
];

export const mensdata = [
  {
    img: "https://www.jiomart.com/images/cms/section/category/503/516.png?v=1628786706",
  },
  {
    img: "https://www.jiomart.com/images/cms/section/category/503/562.png?v=1628786706",
  },
  {
    img: "https://www.jiomart.com/images/cms/section/category/503/515.png?v=1628786706",
  },
  {
    img: "https://www.jiomart.com/images/cms/section/category/503/505.png?v=1628786706",
  },
  {
    img: "https://www.jiomart.com/images/cms/section/category/503/592.png?v=1628786706",
  },
];

export const BigMenData = [
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/503/509.png?v=1628786706",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/503/508.png?v=1628786706",
  },
];

export const KidsFashion = [
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/502/507.png?v=1628783932",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/502/565.png?v=1628783932",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/502/506.png?v=1628783932",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/502/549.png?v=1628783932",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/502/571.png?v=1628783932",
  },
];

export const WowDeal = [
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/501/509.png?v=1628791106",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/501/579.png?v=1628791106",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/501/507.png?v=1628791106",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/501/515.png?v=1628791106",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/501/527.png?v=1628791106",
  },

  {
    image:
      "https://www.jiomart.com/images/cms/section/category/501/516.png?v=1628791106",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/501/530.png?v=1628791106",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/501/508.png?v=1628791106",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/501/584.png?v=1628791106",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/501/525.png?v=1628791106",
  },
];

// Data for groceries===>
export const groceries = [
  {
    image:
      "https://www.jiomart.com/images/category/188/thumb/breakfast-cereals-20200603.png",
  },
  {
    image:
      "https://www.jiomart.com/images/category/117/thumb/dairy-20200522.png",
  },
  {
    image: "https://www.jiomart.com/images/category/17/thumb/0-17.png",
  },
  {
    image: "https://www.jiomart.com/images/category/20/thumb/0-20.png",
  },
  {
    image:
      "https://www.jiomart.com/images/category/119/thumb/bath-hand-wash-20200714.png",
  },
  {
    image:
      "https://www.jiomart.com/images/category/7/thumb/toothpaste-20200520.png",
  },
  {
    image: "https://www.jiomart.com/images/category/26/thumb/0-26.png",
  },
  {
    image:
      "https://www.jiomart.com/images/category/213/thumb/paper-tissues-napkins-20210727.png",
  },
];

//// data for shopCategory===> GrocerieSlider
export const GrocerieSlider = [
  {
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/592200116/saffola-gold-refined-rice-bran-and-sunflower-based-blended-oil-3-l-daawat-devaaya-basmati-rice-5-kg-combo-pack-0-20220624.jpg",
    heading:
      "Saffola Gold Refined Rice Bran And Sunflower Based Blended Oil 3 L + Daawat Devaaya Basmati Rice 5 kg (Combo Pack) ",
    price: "₹ 875.00",
    mrp: "M.R.P:",
    rupees: "₹ 1313",
    save: "Save ₹ 435.00",
  },
  {
    imgSrc:
      "https://www.jiomart.com/images/product/600x600/491055460/colgate-strong-teeth-dental-cream-toothpaste-500-g-saver-pack-product-images-o491055460-p491055460-0-202203151056.jpg",
    heading: "Colgate Strong Teeth Dental Cream Toothpaste 500 g Saver Pack",
    price: "₹ 188.00",
    mrp: "M.R.P:",
    rupees: "₹ 253",
    save: "Save ₹ 65.00",
  },
  {
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/492367966/surf-excel-easy-wash-detergent-powder-5-kg-product-images-o492367966-p590837659-0-202208111657.jpg",
    heading: "Surf Excel Easy Wash Detergent Powder 5 kg",
    price: "₹ 678.00",
    mrp: "M.R.P:",
    rupees: "₹ 730",
    save: "Save ₹ 52.00",
  },
  {
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/490003834/maggi-2-minute-masala-instant-noodles-560-g-product-images-o490003834-p490003834-0-202203150702.jpg",
    heading: "Maggi 2-Minute Masala Instant Noodles 560 g",
    price: "₹ 92.00",
    mrp: "M.R.P:",
    rupees: "₹ 102",
    save: "Save ₹ 17.00",
  },
  {
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/490001392/amul-butter-500-g-carton-product-images-o490001392-p490001392-0-202203152128.jpg",
    heading: "Amul Butter 500 g (Cartoon)",
    price: "₹ 245.00",
    mrp: "M.R.P:",
    rupees: "₹ 255",
    save: "Save ₹ 10.00",
  },
  {
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/490001392/amul-butter-500-g-carton-product-images-o490001392-p490001392-0-202203152128.jpg",
    heading: "Tul / Arhar Dal 2 Kg",
    price: "₹ 252.00",
    mrp: "M.R.P:",
    rupees: "₹ 300",
    save: "Save ₹ 48.00",
  },
  {
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/490008332/closeup-everfresh-red-hot-gel-toothpaste-150-g-pack-of-2-product-images-o490008332-p490008332-0-202206222347.jpg",
    heading: "Closeup Everfresh+ Red Hot Gel Toothpaste 150 g (Pack of 2)",
    price: "₹ 163.00",
    mrp: "M.R.P:",
    rupees: "₹ 182",
    save: "Save ₹ 19.00",
  },
  {
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/492848164/surf-excel-matic-front-load-detergent-powder-6-kg-product-images-o492848164-p591223797-0-202204291101.jpg",
    heading: "Surf Excel Matic Front Load Detergent Powder 6 kg",
    price: "₹ 1325.00",
    mrp: "M.R.P:",
    rupees: "₹ 1425",
    save: "Save ₹ 100.00",
  },
  {
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/492391349/kissan-fresh-tomato-ketchup-1-2-kg-product-images-o492391349-p590809928-0-202203150627.jpg",
    heading: "Kissan Fresh Tomato Ketchup 1.2 Kg",
    price: "₹ 125.00",
    mrp: "M.R.P:",
    rupees: "₹ 160",
    save: "Save ₹ 35.00",
  },
  {
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/490010244/gowardhan-pure-cow-ghee-1-l-pouch-product-images-o490010244-p490010244-0-202203150918.jpg",
    heading: "Govardhan Pure Ghee 1Litre (Pouch)",
    price: "₹ 566.00",
    mrp: "M.R.P:",
    rupees: "₹ 609",
    save: "Save ₹ 43.00",
  },
  {
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/491252835/tide-jasmine-rose-detergent-powder-5-kg-get-extra-1-kg-free-product-images-o491252835-p590838653-0-202203151949.jpg",
    heading: "Tide Jasmine & Rose Detergent Powder 5 Kg",
    price: "₹ 637.00",
    mrp: "M.R.P:",
    rupees: "₹ 635",
    save: "Save ₹ 48.00",
  },
  {
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/491319789/sunfeast-dark-fantasy-original-choco-filled-biscuits-300-g-product-images-o491319789-p491319789-0-202205301919.jpg",
    heading: "Sunfeast Dark Fantasy Original Choco Filled",
    price: "₹ 99.00",
    mrp: "M.R.P:",
    rupees: "₹ 170",
    save: "Save ₹ 71.00",
  },
];

// data for shopCategory===>
export const shopCategory = [
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1657109073_1654018509_Fruits-Veg.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1657109088_1654018530_Beverage-Corner.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1657109143_1656693044_Foodgrains-Oils.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1657109179_1654018570_Snacks-FOOD.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1657109205_1654018587_Home-care.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1657109260_1654018604_personal-Care.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1657109280_1654018629_Dairy-Bakery.jpg",
  },

  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1657109301_1654018647_Instant-Foods.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1657109301_1654018647_Instant-Foods.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1657109327_1654018658_Home-Kitchen.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1657109344_1654018675_Mens-Wear.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1657109379_1654018684_Womens-Wear.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1657109408_1654018699_Kids-WEAR.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1661329065_02--Shop-From-Top-Categories-Kitchen-Appliances.jpg",
  },
];

export const lengthdata = [
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1659964260_Cred-pay-Package_910x278.jpg",
  },

  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1660291721_Twid-Banners-August_910x278.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1660291926_jiomart-svg_910x278_1.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1659290092_Paytm-910-X-278.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1660291926_jiomart-svg_910x278_1.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1659964260_Cred-pay-Package_910x278.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1661239396_910-278-freecharge.jpg",
  },
];

export const categorydata = [
  {
    image:
      "https://www.jiomart.com/images/category/6/thumb/0-6.png?v=1607022291",
    title: "Personal Care",
  },
  {
    image:
      "https://www.jiomart.com/images/category/7/thumb/0-7.png?v=1607022291",
    title: "Home Care",
  },
  {
    image:
      "https://www.jiomart.com/images/category/10/thumb/0-10.png?v=1607022291",
    title: "Baby Care",
  },
  // {
  //     image:"https://www.jiomart.com/images/category/13/thumb/staples-20200710.jpg?v=1607022291",
  //     title:"Staples",
  // },
  {
    image:
      "https://www.jiomart.com/images/category/11/thumb/0-11.png?v=1607022291",
    title: "Snacks and Foods",
  },
  {
    image:
      "https://www.jiomart.com/images/category/12/thumb/0-12.png?v=1607022291",
    title: "Dairy & Bakery",
  },
  {
    image:
      "https://www.jiomart.com/images/category/141/thumb/fruits-vegetables-20200520.png?v=1607022291",
    title: "Fruits & Vegetables",
  },
  {
    image:
      "https://www.jiomart.com/images/category/3/thumb/0-3.png?v=1607022291",
    title: "Beverages",
  },
];

export const BigWomenData = [
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/498/527.png?v=1651706581",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/498/579.png?v=1651706581",
  },
];

export const SmallWomenData = [
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/498/511.png?v=1651706581",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/498/525.png?v=1651706581",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/498/530.png?v=1651706581",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/498/572.png?v=1651706581",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/498/578.png?v=1651706581",
  },
];

export const Personal = [
  {
    image:
      "https://www.jiomart.com/images/category/37/thumb/all-purpose-cleaners-20200603.png",
  },
  {
    image:
      "https://www.jiomart.com/images/category/43/thumb/detergent-bars-20200520.png",
  },
  {
    image:
      "https://www.jiomart.com/images/category/17/thumb/feminine-hygiene-20200605.png",
  },
  {
    image: "https://www.jiomart.com/images/category/28/thumb/0-28.png",
  },
  {
    image:
      "https://www.jiomart.com/images/category/6/thumb/oral-care-20200603.png",
  },
  {
    image: "https://www.jiomart.com/images/category/31/thumb/0-31.png",
  },
  {
    image: "https://www.jiomart.com/images/category/10/thumb/0-10.png",
  },
  {
    image:
      "https://www.jiomart.com/images/category/213/thumb/paper-tissues-napkins-20210727.png",
  },
];

export const HomeData = [
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1661510233_Cheese-creative-Digital-Banner_2.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1645558047_web_mini.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1624538640_wm.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1628171483_Chinese_webmini.jpg",
  },
];

export const Offer = [
  {
    image:
      "https://www.jiomart.com/images/category/188/thumb/breakfast-cereals-20200603.png",
  },
  {
    image:
      "https://www.jiomart.com/images/category/117/thumb/dairy-20200522.png",
  },
  {
    image: "https://www.jiomart.com/images/category/17/thumb/0-17.png",
  },
  {
    image: "https://www.jiomart.com/images/category/15/thumb/0-15.png",
  },
  {
    image: "https://www.jiomart.com/images/category/135/thumb/0-135.png",
  },
  {
    image: "https://www.jiomart.com/images/category/25/thumb/0-25.png",
  },
  {
    image: "https://www.jiomart.com/images/category/26/thumb/0-26.png",
  },
  {
    image:
      "https://www.jiomart.com/images/category/221/thumb/papads-ready-to-fry-20200520.png",
  },
];

export const downData = [
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1661278487_Powered-TB-Banner-4---600X350.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1626259904_wm.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1654538046_600x350-Hot-Spot.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1660816405_01--Apples-Banner_600x350.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1661279354_Apple_Cider_Vinegar-600x350.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1661538125_600x350_kEVENTER.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1661538198_600X350_SENSODYNE.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1660036332_Mobilebanner_StaplesWeek_2_600x350.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1626448037_snackswebmini.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1659004297_600x350-Buy-at-99.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1641903326_Your-Favourite-Noodle_600x350.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1661278487_Powered-TB-Banner-4---600X350.jpg",
  },
];
